import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './notify-cancellation-emails.reducer';
import { INotifyCancellationEmails } from 'app/shared/model/notify-cancellation-emails.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const NotifyCancellationEmails = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const notifyCancellationEmailsList = useAppSelector(state => state.notifyCancellationEmails.entities);
  const loading = useAppSelector(state => state.notifyCancellationEmails.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="notify-cancellation-emails-heading" data-cy="NotifyCancellationEmailsHeading">
        <Translate contentKey="comexApp.notifyCancellationEmails.home.title">Notify Cancellation Emails</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="primary" outline onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="comexApp.notifyCancellationEmails.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="comexApp.notifyCancellationEmails.home.createLabel">Create new Notify Cancellation Emails</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {notifyCancellationEmailsList && notifyCancellationEmailsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="comexApp.notifyCancellationEmails.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="comexApp.notifyCancellationEmails.emailAddress">Email Address</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {notifyCancellationEmailsList.map((notifyCancellationEmails, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${notifyCancellationEmails.id}`} color="link" size="sm">
                      {notifyCancellationEmails.id}
                    </Button>
                  </td>
                  <td>{notifyCancellationEmails.emailAddress}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${notifyCancellationEmails.id}`} size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${notifyCancellationEmails.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${notifyCancellationEmails.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="comexApp.notifyCancellationEmails.home.notFound">No Notify Cancellation Emails found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default NotifyCancellationEmails;
